import { Box } from '@collinsonx/design-system/core';
import useLocale from 'hooks/useLocale';
import useProduct from 'hooks/useProduct';
import { FC } from 'react';

import type { CapacityProps } from '../props';

const CapacityMessage: FC<CapacityProps> = ({ descriptionOverride }) => {
  const translations = useLocale();
  const { isFastTrackEnabled } = useProduct();

  const message =
    descriptionOverride ??
    (isFastTrackEnabled
      ? translations.fastTrack.errors.noAvailability.description
      : translations.lounge.errors.capacity.description.known);

  return (
    <>
      <Box>{message}</Box>
    </>
  );
};

export default CapacityMessage;
